var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTelegramGradient = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 101,
    viewBox: "0 0 95 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.390625 30.7393V70.4238C0.390679 72.2345 0.893148 74.0134 1.84755 75.5814C2.80195 77.1497 4.17467 78.4518 5.82771 79.3572L42.0549 99.1995C43.7081 100.105 45.5833 100.582 47.492 100.582C49.401 100.582 51.276 100.105 52.9291 99.1995L89.1564 79.3572C90.8096 78.4518 92.1822 77.1497 93.1367 75.5814C94.0911 74.0134 94.5935 72.2345 94.5935 70.4238V30.7393C94.5935 28.9286 94.0911 27.1497 93.1367 25.5817C92.1822 24.0134 90.8096 22.7112 89.1564 21.8059L52.9291 1.96358C51.276 1.05819 49.401 0.581543 47.492 0.581543C45.5833 0.581543 43.7081 1.05819 42.0549 1.96358L5.82771 21.8059C4.17467 22.7112 2.80195 24.0134 1.84755 25.5817C0.893148 27.1497 0.390679 28.9286 0.390625 30.7393Z",
    fill: "#4375C5",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.55603 74.5417L3.55596 74.5415C2.78952 73.2823 2.39067 71.8624 2.39062 70.4238V30.7393C2.39062 30.7393 2.39062 30.7393 2.39062 30.7393C2.39068 29.3006 2.78953 27.8807 3.55596 26.6215L3.55603 26.6214C4.32308 25.361 5.43436 24.3016 6.78846 23.56L5.82771 21.8059L6.78847 23.56L43.0157 3.71773C44.3704 2.97577 45.9147 2.58154 47.492 2.58154C49.0696 2.58154 50.6136 2.97576 51.9684 3.71773L88.1957 23.56L88.1957 23.56C89.5499 24.3016 90.661 25.361 91.4282 26.6215L91.4283 26.6216C92.1947 27.8807 92.5935 29.3006 92.5935 30.7393V70.4238C92.5935 71.8625 92.1947 73.2824 91.4283 74.5415L91.4282 74.5416C90.6611 75.8021 89.5499 76.8614 88.1957 77.6031L51.9684 97.4454C50.6137 98.1874 49.0697 98.5815 47.492 98.5815C45.9146 98.5815 44.3704 98.1874 43.0157 97.4454L6.78853 77.6031C6.78851 77.6031 6.78849 77.6031 6.78847 77.6031C5.43431 76.8613 4.32305 75.802 3.55603 74.5417Z",
    stroke: "url(#paint0_linear_13440_32893)",
    strokeWidth: 4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7476 54.953L43.1723 63.0457C43.9954 63.0457 44.352 62.6921 44.7795 62.2675L48.6389 58.5791L56.636 64.4356C58.1026 65.2529 59.1359 64.8225 59.5316 63.0863L64.7808 38.4893L64.7823 38.4879C65.2475 36.3198 63.9982 35.4719 62.5693 36.0038L31.7144 47.8168C29.6086 48.6342 29.6404 49.8081 31.3564 50.34L39.2447 52.7936L57.5678 41.3284C58.4302 40.7574 59.2142 41.0734 58.5693 41.6444L43.7476 54.953Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13440_32893",
    x1: 0.390623,
    y1: 0.342359,
    x2: 114.983,
    y2: 63.1307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4195D2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234375,
    stopColor: "#4195D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463542,
    stopColor: "#4195D2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#4195D2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78125,
    stopColor: "#4195D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4195D2",
    stopOpacity: 0
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTelegramGradient);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/telegram_gradient.085b40f700ef1bd2730f512f11106952.svg";